import ForwardTracker from "../../../../../prop-trackers/forward-tracker.js";
import SinglePropTracker from "../../../../../prop-trackers/single-prop-tracker.js";
import { Mapper, ValueMapper } from "../../../../../prop-tracker-utils/mapper.js";

class MorphTargetFilter extends ForwardTracker {
    constructor(arrayValueTracker, evtCtx, morphTargetInfluences) {
        const mapper = new Mapper(arrayValueTracker, (key) => new FilterMapper(evtCtx));
        super(mapper);
    }
}

class FilterMapper extends ValueMapper {
    constructor(evtCtx) {
        super();

        this._evtCtx = evtCtx;
        this._propTracker = new SinglePropTracker();

        const needsUpdate = () => this.protected_needsUpdate();
        this._propTracker.listenNeedsUpdate(needsUpdate);
    }

    setValue(arrays) {
        this._propTracker.track(arrays, arrays ? this._evtCtx.getEvents(arrays) : null, "morphTargetInfluences");
    }

    deleteValue() {
        this._propTracker.track();
    }

    protected_startUpdate() {
        return this._propTracker.startUpdate();
    }

    protected_finishUpdate() {
        this._propTracker.finishUpdate();
    }
}

export default MorphTargetFilter;
